import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { selector } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per page of the program: plan (teal), teach it (yellow), data & next steps (green) */
const blockStyles = [{
  box: 'bg-mist',
  head: 'text-brand',
  dot: 'bg-brand text-white'
}, {
  box: 'bg-sun-soft',
  head: 'text-ink',
  dot: 'bg-sun text-ink'
}, {
  box: 'bg-leaf-soft',
  head: 'text-leaf-ink',
  dot: 'bg-leaf text-white'
}];

/** "What does your learner need this week?" — pick a goal, see the program that is ready for it */
export function MeetingSelector() {
  const [active, setActive] = useState(0);
  const item = selector.items[active];
  const blocks = [item.open, item.activity, item.close];
  return <section aria-labelledby="selector-title" className="bg-mist py-12 md:py-20" data-id="element-141" data-mp="2i1z8e1l3ik1y">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-142" data-mp="2d2mnhmdsbn20">
        <SectionHeading id="selector-title" eyebrow={selector.eyebrow} title={selector.title} sub={selector.sub} data-id="element-143" data-mp="2d2wcp7r09q6n" />

        <div className="mx-auto mt-8 grid max-w-[980px] gap-5 md:mt-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start" data-id="element-144" data-mp="1pxwci58c45i4">
          <div role="tablist" aria-orientation="vertical" aria-label={selector.tablistLabel} className="flex flex-col gap-2.5" data-id="element-145" data-mp="1g1tcb4x1mgxt">
            {selector.items.map((it, i) => {
            const on = i === active;
            return <button key={it.tab} role="tab" type="button" aria-selected={on} aria-controls="selector-panel" onClick={() => setActive(i)} className={`flex min-h-[56px] w-full items-center justify-between gap-3 rounded-xl border-2 px-4 text-left text-[16px] font-semibold transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand ${on ? 'border-brand bg-white text-brand' : 'border-transparent bg-white text-ink hover:border-mist-line'}`} data-id="element-146" data-mp="28rif9ntbcr22" data-mpi={i}>
                  {it.tab}
                  <ArrowRightIcon className={`h-5 w-5 shrink-0 ${on ? 'text-brand' : 'text-ink/40'}`} strokeWidth={2.25} aria-hidden="true" data-id="element-147" data-mp="2q1w0w9041wi9" />
                </button>;
          })}
          </div>

          <div id="selector-panel" role="tabpanel" className="overflow-hidden rounded-2xl border border-mist-line bg-white" data-id="element-148" data-mp="2g85dz8jmtu4o">
            <div className="bg-brand p-5 md:p-7" data-id="element-149" data-mp="278s3qdnop1iw">
              <p className="font-display text-[11px] font-extrabold tracking-[0.14em] text-sun" data-id="element-150" data-mp="27809b65tp9u7">
                {selector.startLabel} · {item.n}
              </p>
              <h3 className="mt-2 font-display text-[24px] font-black uppercase leading-tight tracking-tight text-white md:text-[28px]" data-id="element-151" data-mp="1xc5lzxqnmql3">{item.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-white/85" data-id="element-152" data-mp="ghk5lzx0hq3">{item.goal}</p>
            </div>

            <div className="space-y-3 p-4 md:p-6" data-id="element-153" data-mp="339u3ovrufmr">
              {blocks.map((list, b) => {
              const s = blockStyles[b];
              return <div key={selector.columns[b]} className={`rounded-xl p-4 ${s.box}`} data-id="element-154" data-mp="80jt9w8yq5ns" data-mpi={b}>
                    <h4 className={`font-display text-[12px] font-black tracking-[0.12em] ${s.head}`} data-id="element-155" data-mp="ctlboe8donc4">{selector.columns[b]}</h4>
                    <ul className="mt-2.5 space-y-2" data-id="element-156" data-mp="hu93h24fl87e">
                      {list.map(line => <li key={line} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-157" data-mp="3gc682my03kpa">
                          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${s.dot}`} data-id="element-158" data-mp="3lapv6qobz2j8">
                            <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-159" data-mp="3v7luq6w94ebn" />
                          </span>
                          {line}
                        </li>)}
                    </ul>
                  </div>;
            })}
              <p className="pt-1 text-center text-[14px] font-medium text-ink/60" data-id="element-160" data-mp="181wyt48eduqe">{selector.note}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}